import { ObjectiveLevelValues } from '@/components/goals/common/objectives'
export const AdaptedGoalValues = {
  GRADE: 'Grade',

  MILD: 'Mild',
  MODERATE: 'Moderate',
  INTENSE: 'Intense',

  // ELL aliased levels
  INTERMEDIATE: 'Mild',
  BEGINNER: 'Moderate',

  // Alt levels
  ATTENTION: 'Attention',
  VISUAL: 'Visual',
  HEARING: 'Hearing',
  PHYSICAL: 'Physical',
  EXPRESSIVE_LANGUAGE: 'Expressive Language',

  // Anchor page objectives
  FIRST: ObjectiveLevelValues.QUARTER_1ST,
  SECOND: ObjectiveLevelValues.QUARTER_2ND,
  THIRD: ObjectiveLevelValues.QUARTER_3RD
}
